"use client";

import { useMemo } from "react";
import { useSessionContext } from "@/contexts/session-context";
import { createAiOutcomeAnalytics } from "@/lib/analytics/ai-outcomes";
import { trackMerchantEvent } from "@/lib/analytics/client";
import type { AiAnalyticsEvents } from "@/lib/analytics/events/ai";

const outcomeAnalytics = createAiOutcomeAnalytics(trackMerchantEvent);

export function useAiOutcomeAnalytics() {
  const { authSessionData, activeShopId } = useSessionContext();
  const userId = authSessionData.user.id;

  return useMemo(() => {
    const scope = { userId, shopId: activeShopId };
    return {
      brainFunnelCreated: (
        properties: AiAnalyticsEvents["brain_funnel_creation_observed"],
      ) => outcomeAnalytics.brainFunnelCreated(scope, properties),
      briefBuildCompleted: (
        properties: AiAnalyticsEvents["strategy_brief_build_completed"],
      ) => outcomeAnalytics.briefBuildCompleted(scope, properties),
    };
  }, [userId, activeShopId]);
}
